import { Paper } from '@material-ui/core';
import styled from 'styled-components';

export const Styled = styled(Paper)`
  > div {
    margin: 0;
  }
`;
